import { ObjectSlotProps } from '../objectScreen.types';

export function ObjectSlot({ children }: ObjectSlotProps) {
  return <>{children}</>;
}
